import React from 'react';

type Props = {
  onClick?: () => void;
  color?: string;
  height?: string;
};
function LogoText({ onClick, color = '#5c74f5', height }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='57.605'
      height='26.5'
      viewBox='0 0 57.605 26.5'
      style={{ marginLeft: 9 }}
    >
      <g
        id='Group_3715'
        data-name='Group 3715'
        transform='translate(-715.763 -243.228)'
      >
        <g id='BETA' style={{ isolation: 'isolate' }}>
          <g
            id='Group_3712'
            data-name='Group 3712'
            style={{ isolation: 'isolate' }}
            fill={color}
          >
            <path
              id='Path_7752'
              data-name='Path 7752'
              d='M751.983,269.668a.19.19,0,0,1-.059-.14v-5.2a.186.186,0,0,1,.059-.144.2.2,0,0,1,.14-.056h2.44a2.3,2.3,0,0,1,1.5.412,1.445,1.445,0,0,1,.492,1.172,1.111,1.111,0,0,1-.2.676,1.308,1.308,0,0,1-.461.4,1.337,1.337,0,0,1,.552.488,1.32,1.32,0,0,1,.225.752,1.55,1.55,0,0,1-.529,1.248,2.258,2.258,0,0,1-1.5.448h-2.512A.193.193,0,0,1,751.983,269.668Zm2.42-3.316a.671.671,0,0,0,.488-.164.578.578,0,0,0,.168-.436.555.555,0,0,0-.168-.424.679.679,0,0,0-.488-.16h-1.04v1.184Zm.072,2.336a.672.672,0,0,0,.512-.192.689.689,0,0,0,0-.94.685.685,0,0,0-.512-.188h-1.112v1.32Z'
            />
            <path
              id='Path_7753'
              data-name='Path 7753'
              d='M757.9,269.668a.19.19,0,0,1-.059-.14v-5.2a.186.186,0,0,1,.059-.144.2.2,0,0,1,.14-.056h3.736a.2.2,0,0,1,.145.056.2.2,0,0,1,.055.144v.752a.2.2,0,0,1-.055.14.191.191,0,0,1-.145.06h-2.552v1.08H761.6a.186.186,0,0,1,.143.06.205.205,0,0,1,.056.148v.7a.2.2,0,0,1-.056.14.186.186,0,0,1-.143.06h-2.377v1.112h2.617a.192.192,0,0,1,.2.2v.752a.2.2,0,0,1-.056.14.188.188,0,0,1-.143.06h-3.8A.192.192,0,0,1,757.9,269.668Z'
            />
            <path
              id='Path_7754'
              data-name='Path 7754'
              d='M764.535,269.668a.191.191,0,0,1-.06-.14v-4.144h-1.424a.192.192,0,0,1-.14-.06.19.19,0,0,1-.059-.14v-.856a.186.186,0,0,1,.059-.144.2.2,0,0,1,.14-.056h4.3a.192.192,0,0,1,.2.2v.856a.2.2,0,0,1-.056.144.192.192,0,0,1-.144.056h-1.423v4.144a.2.2,0,0,1-.057.14.189.189,0,0,1-.145.06h-1.054A.191.191,0,0,1,764.535,269.668Z'
            />
            <path
              id='Path_7755'
              data-name='Path 7755'
              d='M767.566,269.676a.162.162,0,0,1-.051-.116.254.254,0,0,1,.008-.072l1.879-5.136a.3.3,0,0,1,.105-.16.321.321,0,0,1,.208-.064H770.9a.322.322,0,0,1,.209.064.294.294,0,0,1,.1.16l1.872,5.136.016.072a.159.159,0,0,1-.052.116.172.172,0,0,1-.124.052h-.984a.247.247,0,0,1-.255-.168l-.313-.816h-2.137l-.3.816a.254.254,0,0,1-.264.168h-.983A.169.169,0,0,1,767.566,269.676Zm3.485-2.084-.744-2.112-.745,2.112Z'
            />
          </g>
        </g>
        <g id='Group_3706' data-name='Group 3706'>
          <g id='Group_49' data-name='Group 49'>
            <g id='PayPI'>
              <g id='PayPI-2'>
                <g id='Group_544' data-name='Group 544' fill={color}>
                  <path
                    id='Path_535'
                    data-name='Path 535'
                    d='M715.912,257.89a.486.486,0,0,1-.149-.358V243.768a.531.531,0,0,1,.138-.381.479.479,0,0,1,.369-.149h5.668a6.132,6.132,0,0,1,4,1.2,4.263,4.263,0,0,1,1.459,3.5,4.207,4.207,0,0,1-1.449,3.478,6.185,6.185,0,0,1-4.007,1.174h-3.157v4.948a.5.5,0,0,1-.138.358.471.471,0,0,1-.369.149h-2.01A.485.485,0,0,1,715.912,257.89Zm5.921-7.654a2.743,2.743,0,0,0,1.882-.581,2.184,2.184,0,0,0,.654-1.724,2.3,2.3,0,0,0-.633-1.723,2.616,2.616,0,0,0-1.9-.624h-3.088v4.657Z'
                  />
                  <path
                    id='Path_536'
                    data-name='Path 536'
                    d='M731.189,257.817a3.575,3.575,0,0,1-1.418-1.173,2.873,2.873,0,0,1,.645-3.954,6.983,6.983,0,0,1,3.193-1.2l2.9-.423v-.445a1.89,1.89,0,0,0-.465-1.395,2.06,2.06,0,0,0-1.5-.465,2.156,2.156,0,0,0-1.131.264,3.769,3.769,0,0,0-.688.518c-.168.184-.282.3-.339.359a.317.317,0,0,1-.316.254h-1.628a.471.471,0,0,1-.328-.127.443.443,0,0,1-.136-.338,2.291,2.291,0,0,1,.517-1.205,3.919,3.919,0,0,1,1.533-1.163,5.974,5.974,0,0,1,2.537-.486,5.038,5.038,0,0,1,3.637,1.122,3.933,3.933,0,0,1,1.142,2.939v6.639a.505.505,0,0,1-.137.358.481.481,0,0,1-.37.149h-1.713a.508.508,0,0,1-.508-.507v-.825a3.448,3.448,0,0,1-1.321,1.11,4.677,4.677,0,0,1-2.125.434A4.481,4.481,0,0,1,731.189,257.817Zm4.6-2.336a3.061,3.061,0,0,0,.74-2.22v-.443l-2.114.338a4.59,4.59,0,0,0-1.85.612,1.231,1.231,0,0,0-.625,1.036,1.2,1.2,0,0,0,.571,1.057,2.416,2.416,0,0,0,1.375.381,2.536,2.536,0,0,0,1.9-.761Z'
                  />
                  <path
                    id='Path_537'
                    data-name='Path 537'
                    d='M744.2,261.93a.407.407,0,0,1-.128-.3.69.69,0,0,1,.085-.338l1.65-3.912-4.06-9.579a.8.8,0,0,1-.084-.3.56.56,0,0,1,.148-.327.416.416,0,0,1,.317-.138h1.713a.582.582,0,0,1,.57.4l2.812,6.914,2.9-6.914a.589.589,0,0,1,.573-.4h1.691a.446.446,0,0,1,.307.127.39.39,0,0,1,.137.3.863.863,0,0,1-.084.338l-5.984,13.85a.624.624,0,0,1-.591.4H744.5A.407.407,0,0,1,744.2,261.93Z'
                  />
                  <path
                    id='Path_538'
                    data-name='Path 538'
                    d='M755.812,257.89a.486.486,0,0,1-.149-.358V243.768a.535.535,0,0,1,.138-.381.481.481,0,0,1,.37-.149h5.667a6.13,6.13,0,0,1,4,1.2,4.257,4.257,0,0,1,1.459,3.5,4.208,4.208,0,0,1-1.449,3.478,6.183,6.183,0,0,1-4.007,1.174h-3.15v4.948a.5.5,0,0,1-.138.358.471.471,0,0,1-.369.149h-2.01A.484.484,0,0,1,755.812,257.89Zm5.92-7.654a2.743,2.743,0,0,0,1.882-.581,2.185,2.185,0,0,0,.655-1.724,2.3,2.3,0,0,0-.634-1.723,2.616,2.616,0,0,0-1.9-.624h-3.088v4.657Z'
                  />
                  <path
                    id='Path_539'
                    data-name='Path 539'
                    d='M770.507,257.89a.49.49,0,0,1-.147-.358V243.741a.486.486,0,0,1,.147-.37.513.513,0,0,1,.36-.138h1.991a.475.475,0,0,1,.508.438.419.419,0,0,1,0,.07v13.786a.506.506,0,0,1-.137.358.479.479,0,0,1-.371.149H770.87A.486.486,0,0,1,770.507,257.89Z'
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default LogoText;
